export function refreshPage() {
    setTimeout(() => {
        window.location.reload(false);
    });
}